const ProductCPTypes = {
  FETCH_PRODUCT_DAM_FILE_LIST: 'FETCH_PRODUCT_DAM_FILE_LIST',
  DAM_PRODUCT_FILE_SET_FILTER_SORT_DATA: 'DAM_PRODUCT_FILE_SET_FILTER_SORT_DATA',
  SET_PRODUCT_FOLDERS_OPTION: 'SET_PRODUCT_FOLDERS_OPTION',
};

export default ProductCPTypes;
